"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localizationJsonSchema = void 0;
var z = _interopRequireWildcard(require("zod"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * POEditor term key - only characters [a-zA-Z], numbers [0-9] and underscores [_] are allowed.
 */
const keySchema = z.string({
  errorMap: (issue, ctx) => {
    switch (issue.code) {
      case 'invalid_string':
        return {
          message: `Key '${ctx.data}' contains an invalid character. Only characters [a-zA-Z], numbers [0-9] and underscores [_] are allowed.`
        };
      default:
        return {
          message: `Value '${ctx.data}' is not a valid key. Only characters [a-zA-Z], numbers [0-9] and underscores [_] are allowed.`
        };
    }
  }
}).regex(/^\w+$/);

/**
 * POEditor term value - only string is allowed. Objects, arrays, numbers, booleans or null are not allowed.
 */
const valueSchema = z.string({
  errorMap: (issue, ctx) => {
    switch (issue.code) {
      case 'invalid_type':
        return {
          message: `Value '${ctx.data}' is not a valid string. Objects, arrays, numbers, booleans or null are not allowed.`
        };
      default:
        return {
          message: `Value '${ctx.data}' is not a valid string. Objects, arrays, numbers, booleans or null are not allowed.`
        };
    }
  }
});

/**
 * Validation schema for PO Editor localization JSON
 *
 * Term key - only characters [a-zA-Z], numbers [0-9] and underscores [_] are allowed.
 * Term value - only string is allowed. Objects, arrays, numbers, booleans or null are not allowed.
 */
const localizationJsonSchema = exports.localizationJsonSchema = z.record(keySchema, valueSchema);
//# sourceMappingURL=LocalizationJson.js.map